import React, { useEffect, useRef } from 'react';
import { useStoreConfigContext } from '/src/providers';
import * as styles from './styles.scss';

const TrustPilot = () => {
    const { storeConfig: { locale } } = useStoreConfigContext();
    const ref = useRef(null);

    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <div className={styles.trust}>
            <div
                ref={ref}
                className="trustpilot-widget"
                data-locale={locale.replace('_', '-')}
                data-template-id="5406e65db0d04a09e042d5fc"
                data-businessunit-id="4be601cf0000640005096397"
                data-style-height="28px"
                data-style-width="100%"
                data-theme="light"
            />
        </div>
    )
};

export default TrustPilot;
